/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Properties of the original GCP Cloud Sql instance at the time the snapshot was taken. Present only when `resourceType` is set to `GCP_CLOUD_SQL_INSTANCE`. 
*/
export class GcpCloudSqlSnapshotProperties {
  /**
  * The name of the instanceId
  */
  'instanceId'?: string;
  /**
  * The region of the cloud sql instance
  */
  'region'?: string;
  /**
  * The zone of the cloud sql instance
  */
  'zone'?: string;
  /**
  * The database version of the cloud sql instance
  */
  'databaseVersion'?: string;
  /**
  * The network of the cloud sql instance
  */
  'network'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "instanceId",
      "baseName": "instanceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "zone",
      "baseName": "zone",
      "type": "string",
      "format": ""
    },
    {
      "name": "databaseVersion",
      "baseName": "databaseVersion",
      "type": "string",
      "format": ""
    },
    {
      "name": "network",
      "baseName": "network",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpCloudSqlSnapshotProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

